<template>
    <on-click-outside :do="close">
        <div ref="plusbox" class="round mx-2 relative">
            <div class="text-white hover:opacity-75 opacity-100 no-underline referenceElement
                                cursor-pointer"
                 style="transition: all 0.5s"
                 @click.stop.prevent="switchPopper">
                <svg class="ml-2 mt-1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="11"
                     viewBox="0 0 10 11">
                    <defs>
                        <path id="jxwma"
                              d="M1266.33 38.6c0-1.74-1.5-3.16-3.33-3.16a3.25 3.25 0 0 0-3.34
                                                  3.16c0 .97.46 1.83 1.17 2.4a4.4 4.4 0 0 0-2.5 3.93c0 .35.3.63.67.63.36
                                                   0 .66-.28.66-.63 0-1.74 1.5-3.16 3.34-3.16a3.25 3.25 0 0 1 3.33
                                                    3.16c0 .35.3.63.67.63.36 0 .66-.28.66-.63a4.4 4.4 0 0 0-2.5-3.92
                                                     3.1 3.1 0 0 0 1.17-2.4m-3.33 1.88c-1.1 0-2-.85-2-1.9 0-1.04.9-1.88
                                                      2-1.88s2 .84 2 1.89c0 1.04-.9 1.9-2 1.9"/>
                    </defs>
                    <g>
                        <g transform="translate(-1258 -35)">
                            <use fill="#fff" xlink:href="#jxwma"/>
                        </g>
                    </g>
                </svg>
            </div>
            <div ref="popup" class="flex modal-mask absolute mt-3 z-50 -ml-44" v-if="showProfile">
                <div class="modal-wrapper">
                    <div class="modal-container flex flex-col">
                        <div class="mr-1 pin-r arrow absolute"></div>
                        <div class="modal-body mx-4">
                            <div class="flex mt-3">
                                <p class="text-center flex w-full font-medium name">Рустам Н.</p>
                                <svg class="" xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     width="14" height="14" viewBox="0 0 14 14">
                                    <defs>
                                        <path id="xj8oa"
                                              d="M1286.27 91.57a.44.44 0 0 1-.58.25l-.8-.33a1.15 1.15 0 0
                                    0-1.15.23c-.3.3-.4.82-.25 1.18l.33.79c.1.22-.01.48-.24.58l-1.67.7a.44.44
                                    0 0 1-.59-.25l-.32-.79c-.15-.36-.6-.65-.98-.65-.43 0-.87.3-1.02.65l-.33.8a.44.44
                                    0 0 1-.58.24l-1.67-.7a.45.45 0 0 1-.24-.58l.33-.79c.14-.36.04-.88-.24-1.15-
                                    .3-.3-.81-.4-1.17-.25l-.8.32c-.22.1-.48 0-.57-.24l-.7-1.67a.45.45 0 0 1
                                    .25-.59l.79-.33c.36-.15.65-.59.65-.97 0-.43-.3-.86-.65-1.01l-.8-.33a.44.44
                                    0 0 1-.24-.58l.7-1.68c.1-.22.35-.33.58-.24l.79.33c.36.14.88.04
                                    1.15-.23.3-.3.4-.82.26-1.18l-.33-.79c-.1-.23.01-.49.24-.58l1.67-.7c.23-
                                    .09.5.02.58.25l.33.79c.15.36.6.65.98.65.43 0 .87-.3 1.02-.65l.32-.8c.1-
                                    .22.35-.33.59-.24l1.67.7c.22.1.33.35.24.58l-.32.78c-.16.37-.05.89.22
                                    1.16.3.3.82.4 1.19.25l.78-.32c.23-.1.49 0 .58.24l.7 1.68c.09.22-.02.49-
                                    .25.58l-.79.33c-.36.15-.65.59-.65.97 0 .43.29.86.65 1.01l.8.33c.22.1.33
                                    .35.24.58zM1276.5 88a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0zm1.75 0a1.75
                                    1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0z"/>
                                    </defs>
                                    <g>
                                        <g transform="translate(-1273 -81)">
                                            <use fill="#444" xlink:href="#xj8oa"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <hr class="line">
                        </div>
                        <div class="modal-footer mx-4">
                            <slot name="footer flex justify-center text-center">
                                <div class="flex hover:bg-grey-lighter cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="12" height="14" viewBox="0 0 12 14">
                                        <defs>
                                            <path id="oosma"
                                                  d="M1130.29 118.29a4.29 4.29 0 1 0-7.08 3.25 6 6 0 0 0-3.21 5.32.86.86
                                          0 0 0 1.71 0 4.29 4.29 0 0 1 8.58 0 .86.86 0 0 0 1.71 0 6 6 0 0 0-3.21-5.32
                                          4.28 4.28 0 0 0 1.5-3.25m-4.29 2.58a2.57 2.57 0 1 1 0-5.15 2.57 2.57 0 0 1 0
                                          5.15"/>
                                        </defs>
                                        <g>
                                            <g transform="translate(-1120 -114)">
                                                <use fill="#48423b" xlink:href="#oosma"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <p class="modal-default-button p-1 bg-brand-red rounded text-modal w-full mb-1">
                                        Мои команды
                                    </p>
                                </div>
                                <div class="flex hover:bg-grey-lighter cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="14" height="14" viewBox="0 0 14 14">
                                        <defs>
                                            <path id="bvq2a"
                                                  d="M1132.96 146.4l-1.42 7.04a1.96 1.96 0 0 1-1.87 1.56h-7.34a1.96 1.96 0 0
                                          1-1.87-1.56l-1.42-7.03a1.56 1.56 0 0 1 1.54-1.91h1.93a3.5 3.5 0 1 1 6.99
                                          0h1.92a1.55 1.55 0 0 1 1.54 1.9zm-10.82 6.7c.03.08.1.14.2.15h7.33a.24.24
                                          0 0 0 .19-.16l.32-1.59h-8.36l.32 1.6zm2.11-8.6h3.5a1.75 1.75 0 0 0-3.5
                                          0zm-3.48 1.75l.7 3.5h9.07l.7-3.5h-10.48z"/>
                                        </defs>
                                        <g>
                                            <g transform="translate(-1119 -141)">
                                                <use fill="#48423b" xlink:href="#bvq2a"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <p class="modal-default-button p-1 bg-brand-red rounded text-modal w-full mb-1">
                                        Оплатить игру
                                    </p>
                                </div>
                                <div class="flex hover:bg-grey-lighter cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                         width="14" height="15" viewBox="0 0 14 15">
                                        <defs>
                                            <path id="1gn4a"
                                                  d="M1131.26 181.54l-.01-10.5h-4.38a.88.88 0 0 1 0-1.75h4.39c.95 0 1.74.79
                                          1.74 1.75v10.5c0 .97-.78 1.75-1.75 1.75h-4.37a.88.88 0 0 1 0-1.75zm-6.35-
                                          4.38l-2.17 2a.87.87 0 0 0 0 1.24.9.9 0 0 0 1.25 0l3.37-3.19a1.3 1.3 0 0 0
                                          0-1.85l-3.37-3.19a.9.9 0 0 0-1.25 0 .87.87 0 0 0 0 1.24l2.17 2h-5.04a.87.87
                                          0 1 0 0 1.75z"/>
                                        </defs>
                                        <g>
                                            <g transform="translate(-1119 -169)">
                                                <use fill="#48423b" xlink:href="#1gn4a"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <p class="modal-default-button p-1 bg-brand-red rounded text-modal w-full mb-1">
                                        Выйти
                                    </p>
                                </div>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </on-click-outside>
</template>

<script>

import Popper from 'popper.js';
import OnClickOutside from './OnClickOutside';

export default {
  name: 'ShowProfile',
  components: { OnClickOutside },
  data() {
    return {
      hideSelectboxHandler: null,
      showProfile: false,
    };
  },
  created() {
    this.hideSelectboxHandler = () => {
      this.showProfile = false;
    };
  },
  watch: {
    showProfile() {
      if (this.showProfile) {
        this.setupPopper();
        document.addEventListener('click', this.hideSelectboxHandler);
      } else {
        document.removeEventListener('click', this.hideSelectboxHandler);
      }
    },
  },
  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    close() {
      if (!this.showProfile) {
        return;
      }
      this.showProfile = false;
    },
    switchPopper() {
      this.showProfile = !this.showProfile;
      // this.showProfile = false;
      if (this.showProfile) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.plusbox, this.$refs.popup, {
          placement: 'bottom',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },

};

</script>

<style scoped>

    .modal-mask {
        z-index: 9998;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        vertical-align: middle;
    }

    .modal-container {
        width: 200px;
        height: 135px;
        box-shadow: 0 2px 4px rgba(168, 168, 168, 0.06);
        border-radius: 8px;
        background-color: #ffffff;
    }

    .arrow {
        width: 20px;
        height: 14px;
        z-index: -1;
        transform: rotate(-45deg);
        background-color: #ffffff;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 0 0;
    }

    .text-modal {
        color: #444444;
        font-family: "Montserrat Medium";
        font-size: 12px;
        font-weight: 500;
    }

    .line {
        width: 168px;
        border: 1px solid #979797;
    }

    .name {
        color: #bd006c;
        font-family: "Montserrat Medium";
        font-size: 15px;
        font-weight: 700;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>
